import { cloneDeep } from 'lodash';
export class VersionManager {
    // get initial version, ready to insert
    static createVersion(document) {
        if (document == null || document.documentId == null) {
            return null;
        }
        const version = cloneDeep(document);
        if (version._id) {
            delete version._id;
        }
        version.systemHeader.currentVersion = false;
        return version;
    }
}
